export const theme = {
  light: {
    bg: "#f1f1f1",
    shadow: "#b6b6b6",
    text: "#333",
    chartLine: "#b1b1b1",
    chartCircle: "#6f6f6f",
    mobile: "#ffffff",
    soundThumbColor: "#2f2f2f",
    soundBarColor: "#686868",
    controlButton: "#e5e5e5"
  },
  dark: {
    bg: "#222222",
    shadow: "#212121",
    text: "#fff",
    chartLine: "#363636",
    chartCircle: "#9e9e9e",
    mobile: "#2f2f2f",
    soundThumbColor: "#fff",
    soundBarColor: "#686868",
    controlButton: "#444444"
  }
};
